import { i18n } from "@lingui/core";
import { en, zh, ja, vi, ko } from "make-plural/plurals";

// Declare locales
interface ILocale {
  flag: string;
  plurals: (
    n: number | string,
    ord?: boolean
  ) => "zero" | "one" | "two" | "few" | "many" | "other";
}
interface ILocales {
  [locale: string]: ILocale;
}

export const locales: ILocales = {
  en: { flag: "us", plurals: en },
  zh: { flag: "hk", plurals: zh },
  ja: { flag: "jp", plurals: ja },
  vi: { flag: "vn", plurals: vi },
  ko: { flag: "kr", plurals: ko },
};

// Load locale data
for (var [key, locale] of Object.entries(locales)) {
  i18n.loadLocaleData(key, { plurals: locale.plurals });
}

async function fetchLocale(locale: string = "en") {
  const { messages } = await import(
    /* webpackChunkName: "[request]" */ `../locales/translations/olympus-frontend/${locale}/messages`
  );
  i18n.load(locale, messages);
  i18n.activate(locale);
}
export function selectLocale(locale: string) {
  window.localStorage.setItem("locale", locale);
  return fetchLocale(locale);
}
export function initLocale() {
  var locale = window.localStorage.getItem("locale") as string;
  if (!Object.keys(locales).includes(locale)) locale = "en";
  fetchLocale(locale);
}
